module.exports = __webpack_public_path__ + "static/media/review.fd95248d.svg";